import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/login';
import Main from '@/components/main';
import store from '@/store/index';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/main'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {auth: false, system:'', certificate:''},
    },
    {
      path: '/main',
      name: 'Main',
      component: Main,
      meta: {auth: true, system:'', certificate:''},
    },
    {
      path: '*',
      component: Main,
      meta: {auth: true, system:'', certificate:''},
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.auth) {
    let token = store.state.user.token;
    let loginInfo = store.state.user.loginInfo;
    if(token == null || loginInfo == null || loginInfo.Us == null) {
      if(to.path != '/') {
        Vue.prototype.error('您还未登录或登录已超时，请重新登录！');
      }
      next({name: 'Login', path: "/login"});
      return;
    } else {
      if(to.path != '/login') {
        Vue.prototype.post('/user/get-login-info', {
        }).then(resp => {
          if (resp) {
            if (resp.data['success']) {
              next();
            } else {
              Vue.prototype.error('您还未登录或登录已超时，请重新登录！');
              next({name: 'Login', path: "/login"});
            }
          }
        });
      }
    }
  } else {
    next();
  }
});

router.afterEach((to, from, next) => {
  // console.log("from:【" + from.path + "】 to:【" + to.path + "】");
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js